type DarkBackgroundProps = {
  variant?: 'page' | 'section';
  showGrid?: boolean;
};

// Multi-stop radial gradient for a smooth ease-out halo (no harsh edge)
const HALO_GRADIENT = `radial-gradient(ellipse at center,
  hsl(284 100% 49% / 0.055) 0%,
  hsl(284 100% 49% / 0.045) 12%,
  hsl(284 100% 49% / 0.032) 28%,
  hsl(284 100% 49% / 0.018) 46%,
  hsl(284 100% 49% / 0.008) 62%,
  hsl(284 100% 49% / 0.002) 76%,
  transparent 88%
)`;

export function DarkBackground({ variant = 'page', showGrid = false }: DarkBackgroundProps) {
  const position = variant === 'page' ? 'fixed' : 'absolute';
  return (
    <>
      {/* Halo radial — smooth multi-stop ease-out */}
      <div
        className={`${position} inset-0 pointer-events-none`}
        style={{ background: HALO_GRADIENT }}
      />
      {showGrid && (
        <div
          className={`${position} inset-0 opacity-[0.02] pointer-events-none`}
          style={{
            backgroundImage: `linear-gradient(hsl(284 100% 49%) 1px, transparent 5px),
                              linear-gradient(90deg, hsl(284 100% 49%) 1px, transparent 1px)`,
            backgroundSize: '100px 100px',
          }}
        />
      )}
    </>
  );
}
